(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["loyalty-registration"] && !Shopify.designMode) return;
  try {
    const form = document.getElementById('registerForm');
const phoneInput = document.getElementById('phone');
const messageBox = document.getElementById('message');
const btn = form?.querySelector('button');
const endpoint = '/apps/arigato/newmember';
const redirectURL = 'https://mitsukoshi-hivemanila.myshopify.com/customer_authentication/login?return_to=%2F&locale=en';

const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
const phoneRegex = /^09\d{9}$/;

const honeypot = form?.querySelector('input[name="website"]');

// --- reCAPTCHA Enterprise (score-based) -------------------------------
// Liquid is not rendered inside this block, so the key arrives on the
// form's data attributes (set in the section markup above).
const RECAPTCHA_KEY = form?.dataset.recaptchaSiteKey || '';
const RECAPTCHA_ACTION = form?.dataset.recaptchaAction || 'LOYALTY_SIGNUP';
const RECAPTCHA_READY = RECAPTCHA_KEY.length > 20;

// Resolves to a fresh token, or null if reCAPTCHA is unavailable/misconfigured.
function getRecaptchaToken(action) {
  return new Promise((resolve) => {
    if (!RECAPTCHA_READY || !window.grecaptcha || !window.grecaptcha.enterprise) {
      console.warn('reCAPTCHA Enterprise is not loaded — check the site key and the enterprise.js tag.');
      resolve(null);
      return;
    }
    try {
      grecaptcha.enterprise.ready(async () => {
        try {
          resolve(await grecaptcha.enterprise.execute(RECAPTCHA_KEY, { action }));
        } catch (err) {
          console.error('reCAPTCHA execute failed:', err);
          resolve(null);
        }
      });
    } catch (err) {
      console.error('reCAPTCHA ready failed:', err);
      resolve(null);
    }
  });
}

const validity = { first_name: false, last_name: false, email: false, phone: false, accept_terms: false };

// Smart Form Display
document.addEventListener('DOMContentLoaded', () => {
  const loyaltySection = document.getElementById('loyalty-section');
  if (!loyaltySection) return;

  const parent = loyaltySection.parentElement;
  if (!parent) return;

  // Add class to the parent
  parent.classList.add('loyalty-holder-block');

  const loyaltyWidget = parent.querySelector('#loyalty-widget');
  const grandParent = parent.parentElement;

  const emailSignup = document.querySelector('.email-signup-block');

  if (emailSignup) {
    if (loyaltyWidget && window.getComputedStyle(loyaltyWidget).display !== 'none') {
      // Hide loyalty widget if it exists and is visible
      loyaltyWidget.style.display = 'none';

      // Find the first parent with class .image-block
      let current = parent;
      while (current && !current.classList.contains('spacing-style')) {
        current = current.parentElement;
      }

      if (current) {
        // Add class to the found .image-block
        current.classList.add('roland-found');

        // Set current.parent's height to 330px only on desktop
        if (current.parentElement) {
          //current.parentElement.style.height = '330px';
          //current.parentElement.parentElement.parentElement.style.setProperty('--section-min-height', 'unset');
          current.parentElement.parentElement.parentElement.classList.add('member-form-max');
        }

        // Find sibling .image-block elements
        const siblingImageBlocks = Array.from(current.parentElement.children)
          .filter(el => el !== current && el.classList.contains('image-block'));

        siblingImageBlocks.forEach(sibling => {
          const siblingImg = sibling;
          if (siblingImg) {
            siblingImg.style.height = '330px';
            siblingImg.classList.add('max-height-image');
          }
        });
      }

    } else if (!loyaltyWidget) {
      // Hide emailSignup if loyalty widget does NOT exist
      emailSignup.style.display = 'none';
    }

    //alert('welcome');
  } else {
    // assume we're on the signup page, if so hide the form and in its place show the card
    //hideBlocks();
  }
});

if (phoneInput) {
  phoneInput.addEventListener('input', (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.startsWith('63')) value = '0' + value.slice(2);
    if (value.startsWith('+63')) value = '0' + value.slice(3);
    value = value.substring(0, 11);

    let formatted = '';
    if (value.length <= 4) formatted = value;
    else if (value.length <= 7) formatted = value.slice(0,4)+' '+value.slice(4);
    else if (value.length <= 9) formatted = value.slice(0,4)+' '+value.slice(4,7)+' '+value.slice(7);
    else formatted = value.slice(0,4)+' '+value.slice(4,7)+' '+value.slice(7,9)+' '+value.slice(9);

    e.target.value = formatted;
    checkField('phone', phoneRegex.test(value));
  });
}

['first_name','last_name','email','phone'].forEach(id=>{
  const field = document.getElementById(id);
  field?.addEventListener('blur',()=>{
    let valid=false;
    const value = field.value.trim();
    switch(id){
      case 'first_name': case 'last_name': valid = value.length>1; break;
      case 'email': valid = emailRegex.test(value); break;
      case 'phone': valid = phoneRegex.test(value.replace(/\s/g,'')); break;
    }
    highlightField(field, valid);
    checkField(id, valid);
  });
});

const acceptTerms = document.getElementById('accept_terms');
acceptTerms?.addEventListener('change', () => {
  validity.accept_terms = acceptTerms.checked;
  toggleButton();
});

function checkField(field,isValid){
  validity[field]=isValid;
  toggleButton();
}

function toggleButton(){
  if(btn) btn.disabled = registrationLocked || !Object.values(validity).every(v=>v);
}

// --- License lock (V13) ---------------------------------------------------
// When the Omnichannel license is inactive the API refuses sign-ups. Check up
// front so the customer sees the message at once and cannot submit a form that
// would be turned away; the submit handler below also handles a late lock.
const LOCKED_MESSAGE = 'System Unavailable. Try again later.';
let registrationLocked = false;

function lockRegistration(){
  registrationLocked = true;
  if(btn) btn.disabled = true;
  showMessage(LOCKED_MESSAGE,'error');
}

async function checkRegistrationLicense(){
  if(!form) return;
  try{
    const res = await fetch('/apps/arigato/license-status',{headers:{'Accept':'application/json'}});
    const result = await res.json();
    if(result && result.success && result.locked) lockRegistration();
  }catch(err){
    // Can't tell — stay open; the API enforces the lock on submit regardless.
  }
}
checkRegistrationLicense();

function highlightField(field,isValid){
  if(!field) return;
  if(!isValid){ field.classList.add('invalid'); field.classList.remove('valid'); }
  else{ field.classList.remove('invalid'); field.classList.add('valid'); }
}

form?.addEventListener('submit', async (e)=>{
  e.preventDefault();
  if(messageBox) messageBox.style.display='none';
  if(honeypot && honeypot.value) return;

  ['first_name','last_name','email','phone'].forEach(id=>{
    const field = document.getElementById(id);
    if(!field) return;
    let valid=false;
    const value = field.value.trim();
    switch(id){
      case 'first_name': case 'last_name': valid=value.length>0; break;
      case 'email': valid=emailRegex.test(value); break;
      case 'phone': valid=phoneRegex.test(value.replace(/\s/g,'')); break;
    }
    highlightField(field,valid);
    validity[id]=valid;
  });

  if(!Object.values(validity).every(v=>v)){
    showMessage('Please fix the highlighted fields and accept the Terms & Conditions.', 'error');
    return;
  }

  btn.disabled=true; btn.textContent='Submitting...';

  // Fetch the token at submit time — tokens expire after two minutes.
  const recaptchaToken = await getRecaptchaToken(RECAPTCHA_ACTION);
  if(!recaptchaToken){
    showMessage('We could not verify that you are human. Please reload the page and try again.','error');
    btn.disabled=false; btn.textContent='Submit';
    return;
  }

  const data={
    first_name: form.first_name.value.trim(),
    last_name: form.last_name.value.trim(),
    email: form.email.value.trim(),
    phone: phoneInput.value.replace(/\s/g,''),
    recaptcha_token: recaptchaToken,
    recaptcha_action: RECAPTCHA_ACTION
  };

  try{
    const res = await fetch(endpoint,{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify(data)
    });
    const result = await res.json();
    console.log('Server response:',result);

    if(result.locked){
      lockRegistration();
      return;
    }

    if(!res.ok || !result.success){
      let message = result.message || 'An error occurred. Please try again.';
      if(/already exists/i.test(message)){
        message += ` <a href="${redirectURL}" target="_blank" style="color:#007bff;text-decoration:underline;">Sign in instead</a>.`;
        showMemberCard(result,data);
      }
      // retryable = the API says nothing is lost (account/card step hiccup) and
      // resubmitting the same details is safe — it resumes the registration.
      if(result.retryable || res.status >= 500){
        showRetryMessage(message);
      } else {
        showMessageHTML(message,'error');
      }
    } else{
      showMessage('✅ Registration successful! Redirecting...','success');
      showMemberCard(result,data);
    }

  } catch(err){
    console.error(err);
    showRetryMessage('Network or server error. Please try again.');
  } finally{
    btn.disabled=registrationLocked; btn.textContent='Submit';
  }
});

function showMemberCard(result, data) {
  if (result.get_member && result.get_member.card_no && result.get_member.points !== undefined) {
    const regForm = document.querySelector('.reg-form');
    if (regForm) regForm.style.display = 'none';

    const successModule = document.querySelector('.success-module');
    if (successModule) successModule.style.display = 'block';

    const firstName = data.first_name || 'Member';
    const myNameElem = document.querySelector('.my-name');
    if (myNameElem) myNameElem.textContent = 'Welcome ' + firstName + '!';

    const cardNoElem = document.querySelector('.card_no_reg');
    if (cardNoElem) cardNoElem.textContent = result.get_member.card_no;

    const pointsElem = document.querySelector('.points_reg');
    if (pointsElem) pointsElem.textContent = result.get_member.points;

    const qrContainer = document.querySelector('.qrcode-reg');
    if (qrContainer) {
      qrContainer.innerHTML = '';
      new QRCode(qrContainer, { text: result.get_member.card_no, width: 128, height: 128 });
    }

    hideBlocks()
  } else {
    console.warn('Member information is missing.');
  }
}

function hideBlocks() {
  // Select all .group-block-content elements
  const groupBlocks = document.querySelectorAll('.group-block-content');

  groupBlocks.forEach(group => {
    // Check if #loyalty-section exists inside this group
    if (group.querySelector('#loyalty-section')) {
      // Only hide elements inside this group
      const elementsToHide = group.querySelectorAll('.text-block, .welcome-text');
      elementsToHide.forEach(el => {
        el.style.display = 'none';
      });
    }
  });

  // If URL ends with "/sign-up", force grandparent to have min-height: 100vh
  if (window.location.pathname.endsWith('/sign-up')) {
    const someElement = document.querySelector('.reg-form, .success-module'); // Choose a reference element
    if (someElement && someElement.parentElement && someElement.parentElement.parentElement) {
      const grandParent = someElement.parentElement.parentElement.parentElement.parentElement;
      grandParent.classList.add('success-full-height'); // Add your class instead of inline style

      // Check if #loyalty-widget exists
      if (document.querySelector('#loyalty-widget')) {
        grandParent.parentElement?.classList.add('remove-max-paddings');
      }
    }
  }
}

function showMessage(msg,type){
  if(messageBox){
    messageBox.textContent=msg;
    messageBox.className='message '+type;
    messageBox.style.display='block';
  }
}

// Error message followed by a real "Try again" button. Clicking it resubmits the
// form with the details already filled in (a fresh reCAPTCHA token is minted by
// the submit handler each time). The message is set via textContent, never HTML.
function showRetryMessage(msg){
  if(!messageBox) return;
  messageBox.innerHTML='';
  const text=document.createElement('p');
  text.style.margin='0 0 10px';
  text.textContent=msg;
  const retryBtn=document.createElement('button');
  retryBtn.type='button';
  retryBtn.className='button';
  retryBtn.textContent='Try again';
  retryBtn.addEventListener('click',()=>{
    retryBtn.disabled=true;
    if(typeof form.requestSubmit==='function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true}));
  });
  messageBox.appendChild(text);
  messageBox.appendChild(retryBtn);
  messageBox.className='message error';
  messageBox.style.display='block';
}

function showMessageHTML(html,type){
  if(messageBox){
    messageBox.innerHTML=html;
    messageBox.className='message '+type;
    messageBox.style.display='block';
  }
}
  } catch(e) { console.error(e); }
})();

})();
